<template>
  <v-app-bar flat elevation="2" color="white">
    <v-toolbar-title>
      <router-link to="/">
        <v-img src="@/assets/vhp-icon-black.svg" width="70" />
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <ul class="nav">
      <li>
        <router-link to="schedule">Schedule</router-link>
      </li>
      <li>
        <router-link to="faqs">FAQs</router-link>
      </li>
      <li>
        <a href="https://instagram.com/virtualhousepro" target="_blank">
          <v-icon size="28" class="secondary--text">
            fab fa-instagram
          </v-icon>
        </a>
      </li>
    </ul>
  </v-app-bar>
</template>

<script>
export default {
  name: "AdminAppBar",
  data: () => ({
    showLogo: false,
    isScrolling: false,
    selector: "#scheduler"
  }),
  methods: {
    onScroll() {
      const offset = window.pageYOffset;
      this.isScrolling = offset > 50;
      this.showLogo = offset > 200;
    }
  },
  computed: {
    target() {
      const value = this[this.type];
      if (!isNaN(value)) return Number(value);
      else return value;
    },
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.nav {
  list-style: none;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  li {
    list-style: none;
    margin: 0 15px;

    &:last-child {
      margin-right: 5px;
    }

    a {
      color: #333;
      text-decoration: none;

      &:hover {
        color: #000;
      }
    }
  }
}
</style>
